export default "__VITE_ASSET__0177246d__"